import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Observable, combineLatest } from "rxjs";
import { map, take } from "rxjs/operators";
import { UserDbRole } from "../../broker/domain/models/broker.model";
import { UsersBridgeService } from "../users/domain/+state/users-bridge.service";
import { ErrorsService } from "common";

@Injectable({
  providedIn: "root",
})
export class ApiDocsGuard implements CanActivate {
  constructor(
    private readonly bridgeService: UsersBridgeService,
    private readonly errorsService: ErrorsService) { }

  canActivate(
    _next: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return combineLatest([this.bridgeService.getCurrentBroker$(), this.bridgeService.getBrokerDataDetails$()])
      .pipe(
        take(1),
        map(([brokerUser, brokerDetails]) => {
          if ((brokerUser.role === UserDbRole.ADMIN || brokerUser.role === UserDbRole.DEVELOPER) 
                && brokerDetails.apiEnabled) {
            return true;
          }
          this.errorsService.showNotFoundErrorPage();
          return false;
        }
        ))
  }
}
